export const FETCH_SMTP_SETTINGS_REQUEST =
  'smtpSettings/FETCH_SMTP_SETTINGS_REQUEST'
export const FETCH_SMTP_SETTINGS_SUCCESS =
  'smtpSettings/FETCH_SMTP_SETTINGS_SUCCESS'
export const FETCH_SMTP_SETTINGS_FAILURE =
  'smtpSettings/FETCH_SMTP_SETTINGS_FAILURE'

export const UPDATE_SMTP_SETTINGS_REQUEST =
  'smtpSettings/UPDATE_SMTP_SETTINGS_REQUEST'
export const UPDATE_SMTP_SETTINGS_SUCCESS =
  'smtpSettings/UPDATE_SMTP_SETTINGS_SUCCESS'
export const UPDATE_SMTP_SETTINGS_FAILURE =
  'smtpSettings/UPDATE_SMTP_SETTINGS_FAILURE'

export const UPDATE_FIELD = 'smtpSettings/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'smtpSettings/SET_DEFAULT_DATA'
